<template>
    <div>
        <vehicle-picker label="Vehicle" v-model="vehicleProxy" :allow-addition="false" :disabled="disabled"></vehicle-picker>
    </div>
</template>

<script>
    import { VehicleInstanceResource } from '../../../classes/Api/Vehicle'

    export default {
        props: {
            value: {},
            disabled: {
                type: Boolean,
                default: false,
            }
        },
        created() {
            if (this.value) {
                this.lookupAndSet(this.value)
            }
        },
        data() {
            return {
                internal_vehicle: null,
                internal_vehicle_id: null,
            }
        },
        watch: {
            value(n, o) {
                if (n !== o && this.internal_vehicle_id !== n) {
                    this.lookupAndSet(n);
                }
            }
        },
        methods: {
            lookupAndSet(id) {
                if (parseInt(id) > 0) {
                    VehicleInstanceResource.find(id).then(response => {
                        this.internal_vehicle = response.data;
                        this.internal_vehicle_id = id;
                    });
                } else {
                    this.internal_vehicle_id = null
                    this.internal_vehicle = null
                }
            }
        },
        computed: {
            vehicleProxy: {
                get() {
                    if (this.internal_vehicle) {
                        return this.internal_vehicle
                    }

                    return {};
                },
                set(value) {
                    this.internal_vehicle = value;
                    this.internal_vehicle_id = value.id;
                    this.$emit('input', value.id)
                }
            }
        }
    }
</script>